// extracted by mini-css-extract-plugin
export var messageSideLeft = "_hc-1";
export var messageSideRight = "_hc-2";
export var orderLookupBubbleContainer = "_hc-0";
export var submitButton = "_hc-3";